module.exports = __webpack_public_path__ + "static/media/Prescriptions.9ce2d37d.png";